import D1 from "../../components/ExcerciseTypes/Design/TypeIn";
import UI from "../../components/ExcerciseTypes/Design/UserInterface";

const json = {
  1: {
    // Exercise num
    unit: "Unit 1",
    id: "SB3-U1-P12-E1",
    audio: "",
    video: "",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [
      [{ url: "img/FriendsPlus/Page12/E1/1.jpg" }],
      [{ url: "img/FriendsPlus/Page12/E1/2.jpg" }],
    ],
  },
  2: {
    // Exercise num
    unit: "Unit 1",
    id: "SB3-U1-P12-E2",
    audio: "img/FriendsPlus/Page12/Audio/audio-e2-p12.mp3",
    video: "",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [
      [
        { url: "img/FriendsPlus/Page12/E2/1.jpg" },
        {
          url: "img/FriendsPlus/Page12/E2/2.jpg",
          audioUrl: "img/FriendsPlus/Page12/Audio/tieude-e2-p12.mp3",
        },
        { url: "img/FriendsPlus/Page12/E2/3.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page12/E2/4.jpg" }],
    ],
  },
  3: {
    // Exercise num
    unit: "Unit 1",
    id: "SB3-U1-P12-E3",
    audio: "",
    video: "",
    component: D1,
    maxLength: 1,
    typeInput: 'center',
    exerciseKey: "img/FriendsPlus/Page12/E3/Key/answerKey.png",
    titleImage: "",
    questionImage: [
      // Row
      [{ url: "img/FriendsPlus/Page12/E3/1.jpg" }],
      [{ url: "img/FriendsPlus/Page12/E3/16.jpg" }],
      [
        // Column2
        { url: "img/FriendsPlus/Page12/E3/2.jpg" },
        { url: "img/FriendsPlus/Page12/E3/3.jpg", input: true, answer: "F" },
        { url: "img/FriendsPlus/Page12/E3/4.jpg" },
      ],
      [
        // Column3
        { url: "img/FriendsPlus/Page12/E3/5.jpg" },
        { url: "img/FriendsPlus/Page12/E3/6.jpg", input: true, answer: "F" },
        { url: "img/FriendsPlus/Page12/E3/7.jpg" },
        { url: "img/FriendsPlus/Page12/E3/8.jpg", input: true, answer: "T" },
        { url: "img/FriendsPlus/Page12/E3/9.jpg" },
      ],
      [
        // Column4
        { url: "img/FriendsPlus/Page12/E3/10.jpg" },
        { url: "img/FriendsPlus/Page12/E3/11.jpg", input: true, answer: "T" },
        { url: "img/FriendsPlus/Page12/E3/12.jpg" },
        { url: "img/FriendsPlus/Page12/E3/13.jpg", input: true, answer: "T" },
        { url: "img/FriendsPlus/Page12/E3/14.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page12/E3/15.jpg" }],
    ],
  },
};

export default json;
